// apps/client/src/services/projectGeneration.ts

import {
  ChatMessageRole,
  ProjectGenerationDispatchRequestBody,
  ProjectGenerationDispatchResponse,
  ProjectGenerationProgressResponse,
} from '@avanzu/types';
import { apiClient } from './apiClient';

/**
 * Dispatch a project generation job to the background queue
 */
export const dispatchProjectGeneration = async (
  organisationId: string,
  messages: Array<{ role: ChatMessageRole; content: string }>
): Promise<ProjectGenerationDispatchResponse> => {
  const body: ProjectGenerationDispatchRequestBody = { messages };

  const response = await apiClient.post(
    `/organisations/${organisationId}/projects/chat/generate`,
    body
  );

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.message || 'Failed to dispatch project generation');
  }

  return response.json();
};

/**
 * Get the progress of a project generation job
 */
export const getProjectGenerationProgress = async (
  organisationId: string,
  jobId: string
): Promise<ProjectGenerationProgressResponse> => {
  const response = await apiClient.get(
    `/organisations/${organisationId}/projects/chat/generation/${jobId}`
  );

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.message || 'Failed to get project generation progress');
  }

  return response.json();
};
